<div class="block-container" *ngIf="isLoading">
  <div id="loader"></div>
</div>
